export const TiempoExtraEnum = Object.freeze({
  SCHEDULE_EXTENSION: 'Schedule Extension',
  UNDER_TIME: 'Under Time',
  CLIENT_SCHEDULE_EXTENSION: 'Client Schedule Extension'
});
